import _ from "lodash"

/**
 * Cleans and parses emails
 * @param  {String} string
 * @return {Array[String]}
 */
export default function (string) {
  return _.chain(string)
    .toLower()
    .replace(/,/g, " ")
    .replace(/;/g, " ")
    .replace(/>/g, " ")
    .replace(/</g, " ")
    .replace(/\s+/g, " ")
    .split(" ")
    .reject((el) => el === "")
    .reject((el) => el === null)
    .reject((el) => el === undefined)
    .filter((el) => _.includes(el, "@"))
    .value()
}
